import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { StockToggleSlider } from "@models/stock-toggles";
import { config } from "@config";
import { TranslationService } from "@core-services/translation.service";
import { Tradable } from "@models/interfaces/tradable";
import { Stock } from "@models/derivative/currencies/stock";
import { TRADE_TYPE, Warning } from "@models/trade-offer.model";
import { TRADABLES_TYPE } from "@helpers/constants";
import { convertText } from "@helpers/functions";

@Component({
	selector: "stock-toggle",
	templateUrl: "./stock-toggle.component.html",
	styleUrls: ["./stock-toggle.component.scss"],
	standalone: false
})
export class StockToggleComponent implements OnInit {
	@Input() public warnings: Warning[] = [];
	@Input() public showWarning: boolean = false;
	@Input() public showRiskToggle: boolean = false;
	@Input() public actionType: string = "";
	@Input() public entryFlow: string = "";
	@Input() public slider: StockToggleSlider = new StockToggleSlider();
	@Input() public tradable: Tradable = null;
	@Output() public valueUpdate: EventEmitter<StockToggleSlider> = new EventEmitter<StockToggleSlider>();
	@Input() public disabled: boolean = false;

	public constructor(private translationService: TranslationService) {}

	public ngOnInit(): void {
		this.slider.showInvestRisk = this.showRiskToggle;
	}

	public onSliderChange(): void {
		// it should not emit if this is disabled
		if (this.disabled) {
			return;
		}
		return this.valueUpdate.emit(this.slider);
	}

	public isStocksDetails(): boolean {
		return this.tradable instanceof Stock;
	}

	public getTradeType(): string {
		switch (this.actionType) {
			case TRADE_TYPE.RECURRING_BUY:
				return "recurring_buy_modal_summary_confirm_now";
			case TRADE_TYPE.SELL:
				return "finish_sell_button";
			case TRADE_TYPE.BUY:
				return "finish_buy_button";
			case TRADE_TYPE.SWAP:
				return "swap_now";
			case TRADE_TYPE.CHECKOUT:
				return "finish_buy_button";
			case TRADE_TYPE.BUY_ORDER:
				return "limit_order_stock_action_text";
			default:
				return "";
		}
	}

	public getUrl(): string {
		let baseUrl: string = config.baseUrl + "prices/";
		switch (this.tradable.getCurrencyType()) {
			case TRADABLES_TYPE.STOCK:
				baseUrl += config.externalPaths["tradeTerms"]["stocks"];
				break;
			case TRADABLES_TYPE.ETF:
				baseUrl += config.externalPaths["tradeTerms"]["etfs"];
				break;
			case TRADABLES_TYPE.ETC:
				baseUrl += config.externalPaths["tradeTerms"]["etcs"];
				break;
			default:
				baseUrl += config.externalPaths["tradeTerms"]["stocks"];
				break;
		}
		const tradableName: string = convertText(this.tradable.getName());
		const tradableSymbol: string = convertText(this.tradable.getSymbol(true));
		return baseUrl + tradableName + "-" + tradableSymbol + "#downloads";
	}

	public getHelpdeskUrl(warning: Warning): string {
		return this.translationService.getHdLink() + warning.helpdesk_article_id;
	}

	public getActionType(): string {
		if (this.actionType === "recurring-buy") {
			return "buy";
		}
		return this.actionType;
	}
}
